import React, { useState } from 'react'
import './addgallarypage.css';
import { assets } from '../../../assets/assets.js';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';

const AddGallaryPage = () => {
 
  const [formData, setFormData] = useState({
    title: "",
    
    image: null,
  });
  const [isLoading, setIsLoading] = useState(false); 
  const navigate = useNavigate();
  const url = process.env.REACT_APP_BASE_URL


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData((prevData) => ({
        ...prevData,
        image: file, 
      }));
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.title  || !formData.image) {
    toast.error("something is missing title or Image ");
      return;
    }

    setIsLoading(true);
    

    const form = new FormData();
    form.append("title", formData.title);
    // form.append("category", formData.category);
    form.append("image", formData.image);

    try {
      const response = await axios.post(
        `${url}/api/gallery/add`,
        form,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response) {
        toast.success("Image added successfully!")
        setFormData({ title: "", image: null }); 
        navigate("/admin/dashboard/gallery");
      }
    } catch (error) {
      toast.error(  "An error occurred. Please try again.");
      console.error("Error:", error);
     
    } finally {
      setIsLoading(false);
    }
  };


  return (
    <div className='add-image-form'>
     <form action="" onSubmit={handleSubmit}>
      <label htmlFor="title"> Title</label>
      <input type="text" name='title' id='title'  placeholder="Enter image title" value={formData.title} onChange={handleChange}/>
   <p>Upload Image</p>
    <label htmlFor="image">
     <img src={formData.image ? URL.createObjectURL(formData.image) : assets.upload_area} alt="Preview" />
   </label>
      <input type="file" id='image'  name='image' hidden onChange={handleFileChange}/>

     
 
     <button type="submit" disabled={isLoading}>
          {isLoading ? "Adding..." : "Add Image"}
        </button>
      </form>
    
    </div>
  )
}

export default AddGallaryPage